import React, { useEffect, useState } from 'react';
import ReactModal from 'react-modal';
import { Controller, SubmitHandler, useFieldArray, useForm, useWatch } from 'react-hook-form';
import { ReactComponent as ConfirmIcon } from '../../../assets/svg/ConfirmIcon.svg';
import { ReactComponent as DeleteIcon } from '../../../assets/svg/DeleteIcon.svg';
import {
    createNewKvizPitanje,
    createNewPitanje,
    editKvizPitanje,
    editPitanje,
    getKvizPitanjeById,
    getPitanjeById,
} from '../../../server/server-kategorije-tree';
import { notif } from '../../utils/util';
import Loading from '../../../utils/Loading';
import DropDownStrings from '../../DropDownStrings';
import { TezinaPitanja } from '../../../model/enum/tezina-pitanja.enum';
import ImagesForm from '../../media/ImagesForm';
import MDEditor from '@uiw/react-md-editor';
import { text } from 'stream/consumers';
import { GrupaKvizPitanja } from '../../../model/enum/grupe-kviz-pitanja.enum';
import { Autocomplete, Button, Chip, TextField } from '@mui/material';
import { kvizPitanjeTagsLista } from '../../../constatnts/ConstantsQuiz';
import { VrstaKvizPitanja } from '../../../model/enum/vrsta-kviz-pitanja.enum';
import ConnectTable from '../common/ConnectTable';

import 'katex/dist/katex.min.css';
import rehypeKatex from 'rehype-katex';
import remarkMath from 'remark-math';

export interface Connection {
    connections?: { firstItem: string; secondItem: string }[];
}

export interface Inputs {
    naziv: string;
    opis: string;
    tags: string[];
    tezina: string;
    grupa: string;
    vrsta: string;
    redosled: number | undefined;
    visible: boolean;
    connections?: { firstItem: string; secondItem: string }[];
}

const keysArray: string[] = Object.keys(TezinaPitanja).filter((key: any) => isNaN(key));
const keysGrupeKvizPitanja: string[] = Object.keys(GrupaKvizPitanja).filter((key: any) => isNaN(key));
const keysVrsteKvizPitanja: string[] = Object.keys(VrstaKvizPitanja).filter((key: any) => isNaN(key));
const DEFAULT_ODGOVORI_SINGLE = [
    {
        text: '',
        tacan: false,
    },
    {
        text: '',
        tacan: false,
    },
];
const DEFAULT_ODGOVORI_MULTI = [
    {
        text: '',
        tacan: false,
    },
    {
        text: '',
        tacan: false,
    },
    {
        text: '',
        tacan: false,
    },
];

function AddKvizPitanjeModal({ modalIsOpen, closeModal, lekcija, pitanjeId, reloadLekcije }: any) {
    const [errorMessage, setErrorMessage] = useState('');
    const [pitanje, setPitanje] = useState<any>(null);
    const [loading, setLoading] = useState(false);
    const [tezina, setTezina] = useState('Odaberi');
    const [grupa, setGrupa] = useState('Opšte');
    const [vrsta, setVrsta] = useState('Single');
    const [tags, setTags] = useState<string[]>(['Opšte']);
    const [visible, setVisible] = useState(true);
    const [isLekcijaPitanje, setIsLekcijaPitanje] = useState(true);
    const [isKvizPitanje, setIsKvizPitanje] = useState(false);
    const [zaPraksu, setZaPraksu] = useState(true);
    const [zaTakmicenje, setZaTakmicenje] = useState(false);
    const [imagesList, setImagesList] = useState<any>([]);
    const [odgovori, setOdgovori] = useState<any>([]);
    const [val, setVal] = useState<any>('Formula: $E = mc^2$');

    const {
        register,
        unregister,
        handleSubmit,
        watch,
        getValues,
        setValue,
        reset,
        formState: { errors },
        control,
    } = useForm<Inputs>({
        defaultValues: {
            naziv: '',
            opis: '',
            tezina: '',
            grupa: 'Opšte',
            vrsta: 'Single',
            redosled: 0,
        },
    });
    const watchedValues = useWatch<Inputs>({ control });
    const { fields, append, prepend, remove, swap, move, insert } = useFieldArray({
        control,
        name: 'connections',
    });

    useEffect(() => {
        if (!!pitanjeId) loadPitanje();
        else setPitanje(null);
    }, [pitanjeId]);

    const loadPitanje = async () => {
        const resp = await getKvizPitanjeById(pitanjeId);
        if (resp.status == 200) {
            setPitanje(resp.data);
        }
    };

    useEffect(() => {
        if (modalIsOpen) {
            ReactModal.setAppElement('#root');
            setOdgovori(DEFAULT_ODGOVORI_SINGLE);
        }
        console.log('lekcija', lekcija);
    }, [modalIsOpen]);

    useEffect(() => {
        if (!fields.length && vrsta === 'Connect') {
            if (!!pitanje?.listA && !!pitanje.listA?.length && !!pitanje?.listB && !!pitanje?.listB.length && pitanje.listA.length === pitanje.listB.length) {
                const connections = pitanje.listA.map((item: any, index: number) => ({
                    firstItem: item,
                    secondItem: pitanje.listB[index],
                }));
                append(connections);
            } else {
                append([{ firstItem: '', secondItem: '' }]);
            }
        } else {
            remove(); //prvo praznim listu
            unregister('connections'); //posle brisem registraciju
        }
    }, [vrsta]);

    const handleAddField = () => {
        append({ firstItem: '', secondItem: '' });
    };

    const validateFields = (): boolean => {
        const newMap = watchedValues.connections?.map((field) => field.firstItem != '' && !!field.firstItem && field.secondItem !== '' && !!field.secondItem);
        return newMap?.includes(false) ? true : false;
    };
    const disabledAddMore = validateFields();

    useEffect(() => {
        if (!!pitanje?.id) {
            console.log('here');
            setValue('naziv', pitanje.naziv);
            setValue('opis', pitanje.opis);
            setValue('tezina', TezinaPitanja[pitanje.tezina]);
            setValue('grupa', GrupaKvizPitanja[pitanje.grupa]);
            setValue('vrsta', pitanje.vrsta);
            setValue('redosled', pitanje.redosled);
            setVisible(pitanje?.visible);
            setIsLekcijaPitanje(pitanje?.isLekcijaPitanje);
            setIsKvizPitanje(pitanje?.isKvizPitanje);
            setZaPraksu(pitanje?.zaPraksu ?? true);
            setZaTakmicenje(pitanje?.zaTakmicenje ?? false);
            setTezina(TezinaPitanja[pitanje.tezina]);
            setGrupa(GrupaKvizPitanja[pitanje.grupa]);
            setVrsta(pitanje.vrsta);
            setTags(pitanje.tags);
            if (pitanje.oblastImages?.length) setImagesList(reorderImages(pitanje.oblastImages));
            if (pitanje.odgovori?.length) setOdgovori(reorderOdgovori(pitanje.odgovori));
        }
    }, [pitanje]);
    const onSubmit: SubmitHandler<Inputs> = async () => {
        if (!!pitanje?.id) updatePitanje();
        else {
            createPitanje();
        }
    };
    const createPitanje = async () => {
        console.log('values ', getValues());
        if (vrsta === 'Single' && !validate()) return;
        setLoading(true);
        let data: any = getValues();
        data.redosled = getValues('redosled')?.toString();
        data.lekcijaId = lekcija?.id;
        data.tags = tags;
        data.visible = visible;
        data.isLekcijaPitanje = isLekcijaPitanje;
        data.isKvizPitanje = isKvizPitanje;
        data.zaPraksu = zaPraksu;
        data.zaTakmicenje = zaTakmicenje;
        if (imagesList.length) data.files = imagesList;
        data.odgovori = odgovori;
        if (vrsta === 'Connect') {
            delete data.connections;
            const listA = getValues('connections')?.map((field) => field.firstItem);
            const listB = getValues('connections')?.map((field) => field.secondItem);
            data.listA = listA;
            data.listB = listB;
        }
        const resp = await createNewKvizPitanje(data);
        if (resp.status == 201) {
            reloadLekcije();
            notif('Uspešno ste kreirali novo kviz pitanje!');
            setLoading(false);
            closeModal();
        } else {
            setLoading(false);
        }
    };
    const updatePitanje = async () => {
        if ((vrsta === 'Single' || vrsta === 'Multi') && !validate()) return;
        setLoading(true);
        let data: any = getValues();
        data.id = pitanje?.id;
        data.redosled = getValues('redosled')?.toString();
        data.lekcijaId = lekcija?.id;
        data.tags = tags;
        data.visible = visible;
        data.isLekcijaPitanje = isLekcijaPitanje;
        data.isKvizPitanje = isKvizPitanje;
        data.zaPraksu = zaPraksu;
        data.zaTakmicenje = zaTakmicenje;
        data.odgovori = odgovori;
        if (vrsta === 'Connect') {
            delete data.connections; // brisemo ovo polje jer ne postoji u bazi a kada vrsta!=='Connect' to polje i ne postoji
            const listA = getValues('connections')?.map((field) => field.firstItem);
            const listB = getValues('connections')?.map((field) => field.secondItem);
            data.listA = listA;
            data.listB = listB;
        } else {
            data.listA = [];
            data.listB = [];
        }
        if (imagesList.length > 0) {
            data.files = imagesList;
        }
        console.log('update ', data);
        const resp = await editKvizPitanje(data);
        if (resp.status == 201) {
            reloadLekcije();
            notif('Uspešno ste izmenili kviz pitanje!');
            setLoading(false);
            closeModal();
        } else {
            setLoading(false);
        }
    };

    const reorderImages = (files: any) => {
        return !!files.length
            ? files.map((item: any) => {
                  return { id: item?.image?.id, redosled: item?.redosled };
              })
            : [];
    };

    const reorderOdgovori = (odgovori: any) => {
        return !!odgovori.length
            ? odgovori.map((item: any) => {
                  return { text: item.text, tacan: item.tacan };
              })
            : [];
    };

    const setSelectedTezina = (item: any) => {
        setValue('tezina', item, { shouldValidate: true });
        setTezina(!!item ? item : 'Odaberi');
    };
    const setSelectedGrupa = (item: any) => {
        setValue('grupa', item, { shouldValidate: true });
        setGrupa(!!item ? item : 'Odaberi');
    };

    const setSelectedVrsta = (item: any) => {
        setValue('vrsta', item, { shouldValidate: true });
        setVrsta(!!item ? item : 'Odaberi');
        if (item === 'Single') setOdgovori(DEFAULT_ODGOVORI_SINGLE);
        if (item === 'Multi') setOdgovori(DEFAULT_ODGOVORI_MULTI);
    };
    const changeVisibilty = () => {
        setVisible((prev) => !prev);
    };

    const changeIsKvizPitanje = () => {
        setIsKvizPitanje((prev) => !prev);
    };

    const changeIsLekcijaPitanje = () => {
        setIsLekcijaPitanje((prev) => !prev);
    };

    const changeZaPraksu = () => {
        setZaPraksu((prev) => !prev);
    };

    const changeZaTakmicenje = () => {
        setZaTakmicenje((prev) => !prev);
    };

    const _removeValue = (arr: any[], x: any) => {
        arr.splice(x, 1);
        return arr;
    };

    const handleAddOdgovor = () => {
        let newList = [...odgovori, { text: '', tacan: false }];
        setOdgovori(newList);
    };

    const removeOdgovor = (index: number) => {
        let newList = _removeValue([...odgovori], index);
        setOdgovori(newList);
    };

    const handleTacanOdgovorSingle = (index: number) => {
        let newList = odgovori.map((odgovor: any, i: number) => {
            if (i === index) return { text: odgovor.text, tacan: true };
            else {
                return { text: odgovor.text, tacan: false };
            }
        });
        setOdgovori(newList);
    };

    const handleTacanOdgovorMulti = (index: number) => {
        let newList = odgovori.map((odgovor: any, i: number) => {
            if (i === index) {
                return { ...odgovor, tacan: !odgovor.tacan }; // Menja trenutno stanje polja tacan
            }
            return odgovor; // Ostali ostaju nepromenjeni
        });

        setOdgovori(newList);
    };

    const handleOdgovor = (value: any, index: number) => {
        setErrorMessage('');
        let newList = [...odgovori];
        let odgovor = newList[index];
        newList.splice(index, 1, { text: value, tacan: odgovor.tacan });
        setOdgovori(newList);
    };

    const checkIfDuplicateExists = (arr: any[]) => {
        var newList = arr.map((item: any) => {
            return item.text;
        });
        return new Set(newList).size !== newList.length;
    };

    const checkIfCorrectAnswerExists = (arr: any[]) => {
        var newList = arr.filter((item: any) => item.tacan);
        return newList.length !== 1;
    };

    const checkIfMultiCorrectAnswerExists = (arr: any[]) => {
        if (arr.length < 3) return false; // Provera da lista ima barem tri člana

        const correctAnswers = arr.filter((item) => item.tacan).length;
        const incorrectAnswers = arr.filter((item) => !item.tacan).length;

        return !(correctAnswers >= 2 && incorrectAnswers >= 1);
    };

    const validate = () => {
        let valid = true;
        odgovori.forEach((element: any) => {
            if (element.text === '') {
                setErrorMessage('Popunite sva polja za odgovore');
                valid = false;
            }
        });
        if (valid && checkIfDuplicateExists(odgovori)) {
            setErrorMessage('Imate dva ili više istih odgovora');
            valid = false;
        }
        if (valid && vrsta === 'Single' && checkIfCorrectAnswerExists(odgovori)) {
            setErrorMessage('Odaberite tačan odgovor');
            valid = false;
        }
        if (valid && vrsta === 'Multi' && checkIfMultiCorrectAnswerExists(odgovori)) {
            setErrorMessage('Odaberite barem dva tačna odgovora ali ne smeju svi odgovori bit tačni');
            valid = false;
        }
        return valid;
    };

    const cleanModalData = () => {
        reset();
        setTezina('Odaberi');
        setGrupa('Opšte');
        setVrsta('Single');
        setTags(['Opšte']);
        setVisible(true);
        setIsKvizPitanje(false);
        setIsLekcijaPitanje(true);
        setZaPraksu(true);
        setZaTakmicenje(false);
        setImagesList([]);
        setOdgovori([]);
        setLoading(false);
        setErrorMessage('');
    };

    return (
        <ReactModal
            ariaHideApp={false}
            isOpen={modalIsOpen}
            onAfterOpen={() => {}}
            onAfterClose={() => cleanModalData()}
            onRequestClose={closeModal}
            className="no-scroll"
            style={{
                overlay: {
                    zIndex: 7,
                    backdropFilter: 'brightness(30%)',
                },
                content: {
                    padding: 0,
                    opacity: 1,
                    width: 1000,
                    margin: 'auto',
                    backgroundColor: 'transparent',
                    height: '100%',
                    maxHeight: '100%',
                    border: 'none',
                    boxShadow: 'none',
                    overflow: 'auto',
                    paddingTop: 15,
                    paddingBottom: 15,
                },
            }}
        >
            <div className="   max-h-[600px] w-full  ">
                <form className="flex flex-col items-center w-full bg-white  py-[30px] rounded-[10px]" onSubmit={handleSubmit(onSubmit)} autoComplete="off">
                    <div className="flex flex-col w-full px-[40px]">
                        <label className="text-[16px] leading-5 text-black700 font-bold  ">Naziv kviz pitanja</label>

                        <Controller
                            control={control}
                            name="naziv"
                            rules={{ required: true }}
                            render={({ field }) => (
                                <MDEditor
                                    style={{ maxHeight: 540 }}
                                    value={field.value}
                                    onChange={(value: any) => setValue('naziv', value, { shouldValidate: true })}
                                    preview="live"
                                    previewOptions={{
                                        remarkPlugins: [remarkMath],
                                        rehypePlugins: [rehypeKatex],
                                    }}
                                />
                            )}
                        />

                        <p className="text-redError text-[12px] leading-5 h-5 ">
                            <span>{errors.naziv?.type === 'required' ? 'Obavezno popunite ovo polje!' : ''} </span>
                        </p>
                    </div>
                    <div className="flex flex-col w-full px-[40px]">
                        <label className="text-[16px] leading-5 text-black700 font-bold  ">Opis kviz pitanja</label>
                        <Controller
                            control={control}
                            name="opis"
                            rules={{ required: true }}
                            render={({ field }) => (
                                <MDEditor
                                    style={{ maxHeight: 540, minHeight: 300 }}
                                    value={field.value}
                                    onChange={(value: any) => setValue('opis', value, { shouldValidate: true })}
                                    preview="live"
                                    previewOptions={{
                                        remarkPlugins: [remarkMath],
                                        rehypePlugins: [rehypeKatex],
                                    }}
                                />
                            )}
                        />
                        <p className="text-redError text-[12px] leading-5 h-5 ">
                            <span>{errors.opis?.type === 'required' ? 'Obavezno popunite ovo polje!' : ''} </span>
                        </p>
                    </div>
                    {lekcija?.isSurvey && (
                        <div className="my-4 rounded-lg w-full bg-orange-100 px-[40px]">
                            <DropDownStrings
                                list={keysVrsteKvizPitanja}
                                register={register}
                                registerField="vrsta"
                                errors={errors.vrsta?.type}
                                label="Vrsta kviz pitanja"
                                selectedValue={vrsta}
                                setSelectedValue={setSelectedVrsta}
                            />
                        </div>
                    )}
                    {vrsta === 'Connect' && (
                        <div className="w-full bg-yellow-50 px-[10px]">
                            <div className="w-[calc(100%+160px)] h-[1px] bg-gold -ml-[80px]"></div>
                            <ConnectTable fields={fields} remove={remove} control={control} errors={errors} />
                            <p className="ml-5 min-h-[30px] text-textError text-[0.75rem] text-redError leading-[30px]">
                                {errors['connections'] ? 'Popunite obavezno polje' : ''}
                            </p>
                            <Button variant="contained" onClick={handleAddField} disabled={disabledAddMore} style={{ marginTop: 10 }}>
                                Dodaj novi par odgovora
                            </Button>
                            <div className="w-[calc(100%+160px)] h-[1px] bg-gold -ml-[80px] mt-2"></div>
                        </div>
                    )}
                    {(vrsta === 'Single' || vrsta === 'Multi') && (
                        <div className="w-full bg-yellow-50 px-[40px]">
                            <div className="w-[calc(100%+160px)] h-[2px] bg-gold -ml-[80px]"></div>
                            <div className="w-full flex flex-col mt-3 gap-3">
                                {odgovori?.map((odgovor: any, index: number) => {
                                    return (
                                        <div className="flex flex-col w-full gap-2" key={index}>
                                            <div className="flex flex-row justify-between ">
                                                <label className="text-[16px] leading-5 text-black700 font-bold  ">Odgovor {index + 1}</label>
                                                <div className="flex flex-row gap-5 items-center">
                                                    <div className="w-full">
                                                        <div className={`flex flex-row items-center cursor-pointer `}>
                                                            <div
                                                                className="border border-blueDark rounded-full h-[24px] w-[24px] flex items-center justify-center"
                                                                onClick={() => {
                                                                    if (vrsta === 'Single') {
                                                                        handleTacanOdgovorSingle(index);
                                                                    } else {
                                                                        handleTacanOdgovorMulti(index);
                                                                    }
                                                                }}
                                                            >
                                                                {odgovor.tacan && <div className="rounded-full h-[16px] min-w-[16px] bg-blueDark"></div>}
                                                            </div>
                                                            <label className="text-black text-[16px] font-medium ml-[13px] cursor-pointer not-selectable">
                                                                Tačan odgovor
                                                            </label>
                                                        </div>
                                                    </div>
                                                    {vrsta === 'Single'
                                                        ? odgovori.length > 2 && (
                                                              <div className="cursor-pointer" onClick={() => removeOdgovor(index)}>
                                                                  <DeleteIcon />
                                                              </div>
                                                          )
                                                        : odgovori.length > 3 && (
                                                              <div className="cursor-pointer" onClick={() => removeOdgovor(index)}>
                                                                  <DeleteIcon />
                                                              </div>
                                                          )}
                                                </div>
                                            </div>
                                            <MDEditor
                                                style={{ maxHeight: 140 }}
                                                value={odgovor?.text}
                                                onChange={(value: any) => handleOdgovor(value, index)}
                                                preview="live"
                                                previewOptions={{
                                                    remarkPlugins: [remarkMath],
                                                    rehypePlugins: [rehypeKatex],
                                                }}
                                            />
                                        </div>
                                    );
                                })}
                            </div>
                            <div
                                className=" border border-primaryViolet flex items-center justify-center cursor-pointer rounded-xl py-3 w-full font-semibold text-base text-primaryViolet mt-3"
                                onClick={() => handleAddOdgovor()}
                            >
                                Dodaj odgovor
                            </div>
                            <div className="w-[calc(100%+160px)] h-[2px] bg-gold -ml-[80px]  mt-3"></div>
                        </div>
                    )}
                    <div className="mt-4 w-full px-[40px]">
                        <ImagesForm imagesList={imagesList} setImagesList={setImagesList} />
                    </div>

                    <div className="mt-4 w-full px-[40px]">
                        <DropDownStrings
                            list={keysArray}
                            register={register}
                            registerField="tezina"
                            errors={errors.tezina?.type}
                            label="Težina pitanja"
                            selectedValue={tezina}
                            setSelectedValue={setSelectedTezina}
                        />
                    </div>
                    <div className="mt-4 w-full px-[40px]">
                        <DropDownStrings
                            list={keysGrupeKvizPitanja}
                            register={register}
                            registerField="grupa"
                            errors={errors.grupa?.type}
                            label="Grupa pitanja"
                            selectedValue={grupa}
                            setSelectedValue={setSelectedGrupa}
                        />
                    </div>
                    <div className="mt-4 w-full px-[40px]">
                        <Autocomplete
                            multiple
                            id="tags-filled"
                            options={kvizPitanjeTagsLista.map((option) => option?.title)}
                            defaultValue={[kvizPitanjeTagsLista[0]?.title]}
                            freeSolo
                            renderTags={(value: readonly string[], getTagProps) =>
                                value.map((option: string, index: number) => {
                                    const { key, ...tagProps } = getTagProps({ index });
                                    return <Chip variant="outlined" label={option} key={key} {...tagProps} style={{ marginTop: 15, marginBottom: 5 }} />;
                                })
                            }
                            onChange={(event, newValue) => setTags(newValue)}
                            renderInput={(params) => <TextField {...params} variant="filled" label="tagovi" placeholder="Favoriti" />}
                            value={tags}
                        />
                    </div>
                    <div className="flex flex-col w-full mt-4 px-[40px]">
                        <label className="text-[16px] leading-5 text-black700 font-bold  ">Redosled pitanja</label>
                        <div className="bg-white border border-black200 rounded-[4px] h-[48px] w-full px-3 flex flex-row items-center mt-2">
                            <input
                                className="text-[16px] leading-5 text-black700  w-full outline-none  placeholder:text-black200 "
                                placeholder="Redosled pitanja"
                                type="number"
                                {...register('redosled', {
                                    min: 0,
                                })}
                            />
                        </div>
                        <p className="text-redError text-[12px]  leading-5 h-5 ">
                            <span>{errors.redosled?.type === 'min' ? 'Vrednost mora biti pozitivan broj!' : ''} </span>
                        </p>
                    </div>
                    <div className="w-full px-[40px]">
                        <div className={`flex flex-row items-center cursor-pointer my-2`}>
                            <div
                                className="border-[1.5px] border-black rounded-full h-[18px] w-[18px] flex items-center justify-center"
                                onClick={() => changeIsLekcijaPitanje()}
                            >
                                {isLekcijaPitanje && <div className="rounded-full h-[10px] w-[10px] bg-black"></div>}
                            </div>
                            <label className="text-black text-[16px] font-medium ml-[13px] cursor-pointer not-selectable">Da li je ovo lekcija pitanje?</label>
                        </div>
                    </div>
                    <div className="w-full px-[40px]">
                        <div className={`flex flex-row items-center cursor-pointer my-2`}>
                            <div
                                className="border-[1.5px] border-black rounded-full h-[18px] w-[18px] flex items-center justify-center"
                                onClick={() => changeIsKvizPitanje()}
                            >
                                {isKvizPitanje && <div className="rounded-full h-[10px] w-[10px] bg-black"></div>}
                            </div>
                            <label className="text-black text-[16px] font-medium ml-[13px] cursor-pointer not-selectable">Da li je ovo kviz pitanje?</label>
                        </div>
                    </div>
                    <div className="w-full px-[40px]">
                        <div className={`flex flex-row items-center cursor-pointer my-2`}>
                            <div
                                className="border-[1.5px] border-black rounded-full h-[18px] w-[18px] flex items-center justify-center"
                                onClick={() => changeVisibilty()}
                            >
                                {visible && <div className="rounded-full h-[10px] w-[10px] bg-black"></div>}
                            </div>
                            <label className="text-black text-[16px] font-medium ml-[13px] cursor-pointer not-selectable">Kviz pitanje vidljivo</label>
                        </div>
                    </div>
                    <div className="w-full px-[40px]">
                        <div className={`flex flex-row items-center cursor-pointer my-2`}>
                            <div
                                className="border-[1.5px] border-black rounded-full h-[18px] w-[18px] flex items-center justify-center"
                                onClick={() => changeZaPraksu()}
                            >
                                {zaPraksu && <div className="rounded-full h-[10px] w-[10px] bg-black"></div>}
                            </div>
                            <label className="text-black text-[16px] font-medium ml-[13px] cursor-pointer not-selectable">
                                Kviz Lovac - dostupno za vežbanje
                            </label>
                        </div>
                    </div>
                    <div className="w-full px-[40px]">
                        <div className={`flex flex-row items-center cursor-pointer my-2`}>
                            <div
                                className="border-[1.5px] border-black rounded-full h-[18px] w-[18px] flex items-center justify-center"
                                onClick={() => changeZaTakmicenje()}
                            >
                                {zaTakmicenje && <div className="rounded-full h-[10px] w-[10px] bg-black"></div>}
                            </div>
                            <label className="text-black text-[16px] font-medium ml-[13px] cursor-pointer not-selectable">
                                Kviz Lovac - dostupno za takmičenje (pojavljuje se na nivou piramide koji odgovara težini: Srednje → dno/1. korak,
                                Teško → 2-3. korak, Napredno → pred vrh)
                            </label>
                        </div>
                    </div>
                    <p className="text-redError text-[12px] leading-5 h-5 px-[40px]">{!!errorMessage ? errorMessage : ''}</p>
                    <div className="w-full flex flex-row gap-5 justify-end px-[40px]">
                        <button
                            type="button"
                            className={`px-5 h-[48px] flex items-center justify-center bg-white border border-black200 rounded-[4px] text-[18px] text-black700 font-bold cursor-pointer`}
                            onClick={(e) => {
                                e.preventDefault();
                                closeModal();
                            }}
                        >
                            <p>Otkaži</p>
                        </button>
                        <button
                            type="submit"
                            className={`px-5 h-[48px] flex items-center justify-center bg-white border border-black200 rounded-[4px] text-[18px] text-black700 font-bold cursor-pointer`}
                            disabled={loading}
                        >
                            {loading ? (
                                <Loading size={25} />
                            ) : (
                                <div className="w-full flex flex-row items-center justify-center gap-3">
                                    <ConfirmIcon />
                                    <p>Potvrdi</p>
                                </div>
                            )}
                        </button>
                    </div>
                </form>
            </div>
        </ReactModal>
    );
}

export default AddKvizPitanjeModal;
